import React from "react";
import { useTranslation } from "react-i18next";

const EMAIL_STATUS = {
  sent: { key: "admin.statusSent", cls: "bg-success/10 text-success" },
  failed: { key: "admin.statusFailed", cls: "bg-destructive/10 text-destructive" },
  queued: { key: "admin.statusQueued", cls: "bg-secondary text-muted-foreground" },
  mocked: { key: "admin.mocked", cls: "bg-warning/10 text-warning" },
};

export function EmailStatus({ status }) {
  const { t } = useTranslation();
  const s = EMAIL_STATUS[status] || EMAIL_STATUS.mocked;
  return (
    <span data-testid={`email-status-${status || "mocked"}`} className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${s.cls}`}>
      {t(s.key)}
    </span>
  );
}
